import * as React from 'react';
const h = React.createElement;
import { icons } from '../icons';

export type TagColor =
  | 'blue'
  | 'green'
  | 'red'
  | 'orange'
  | 'yellow'
  | 'purple'
  | 'cyan'
  | 'default';

export interface TagProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'onClose'> {
  color?: TagColor | string;
  children?: React.ReactNode;
  className?: string;
  closable?: boolean;
  onClose?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  icon?: React.ReactNode;
}

const Tag: React.FC<TagProps> = function Tag(props) {
  const { color, children, className = '', closable = false, onClose, icon, ...rest } = props;
  const colorMap: Record<string, string> = {
    blue: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
    green: 'bg-green-500/15 text-green-400 border-green-500/30',
    red: 'bg-red-500/15 text-red-400 border-red-500/30',
    orange: 'bg-orange-500/15 text-orange-400 border-orange-500/30',
    yellow: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30',
    purple: 'bg-purple-500/15 text-purple-400 border-purple-500/30',
    cyan: 'bg-cyan-500/15 text-cyan-400 border-cyan-500/30',
    default: 'bg-dark-700 text-dark-300 border-dark-600',
  };
  const colorClass = (color && colorMap[color]) || colorMap.default;

  return h(
    'span',
    {
      className: `inline-flex items-center gap-1 px-2.5 py-0.5 rounded-md border text-xs font-medium ${colorClass} ${className}`,
      ...rest,
    },
    icon && h('span', { className: 'text-[0.7em]' }, icon),
    children,
    closable &&
      h(
        'span',
        {
          className: 'ml-1 cursor-pointer opacity-60 hover:opacity-100 transition-opacity',
          onClick: onClose,
        },
        h(icons.CloseCircleOutlined, { size: '0.65em' }),
      ),
  );
};

export { Tag };
